import LampOutlineIcon from '@eduzz/houston-icons/LampOutline';
import Layout from '@eduzz/houston-ui/Layout';
import Tooltip from '@material-ui/core/Tooltip';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import ChatMessages from 'v2/components/Shared/ChatMessages';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import Affiliations from './Affiliations';
import iconMyEduzz from './myeduzz-symbol.svg';
import logoMyEduzz from './myeduzz.svg';
import NoPartner from './NoPartner';
import Notifications from './Notifications';
import ProfileMenu from './ProfileMenu';

const { Topbar } = Layout;

type LogoWrapperProps = {
  className: string;
  children: React.ReactNode;
};
function LogoWrapper({ className, children }: LogoWrapperProps) {
  return (
    <Link className={className} to='/producer/dashboard'>
      {children}
    </Link>
  );
}

function Toolbar() {
  const [ModuleTopbarSearch] = useObservable(() => {
    return eduzzAccountsService.getUserVertical().pipe(
      switchMap((user) => {
        console.clear();
        return from(import('@myeduzz-vertical/root/modules').then((d) => d.getModules(user as any)));
      }),
      map((modules) => {
        return modules.find((m) => m.name === 'global-search')?.topbarSearch;
      })
    );
  }, []);

  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const isPartner = user?.acceptence_terms;

  const redirectToSpace = React.useCallback(() => {
    window.open('https://space.eduzz.com');
  }, []);

  if (!user) {
    return null;
  }

  const toolbarUser = eduzzAccountsService.getUserToolbar();

  return (
    <Topbar
      currentApplication='orbita'
      disableApps={!isPartner}
      user={toolbarUser}
      logo={logoMyEduzz}
      logoMobile={iconMyEduzz}
      logoWrapper={LogoWrapper}
    >
      <Topbar.UnitySupportChat />

      {ModuleTopbarSearch && (
        <React.Suspense fallback={<></>}>
          <ModuleTopbarSearch SearchComponent={Topbar.Search} React={React} runOnOrbita />
        </React.Suspense>
      )}

      {isPartner ? (
        <>
          <PermissionHide>
            <Affiliations />
          </PermissionHide>

          <PermissionHide action='myeduzz:meus-afiliados:visualizar'>
            <ChatMessages />
          </PermissionHide>

          <Notifications />

          <PermissionHide userTypes={['producer', 'affiliate']}>
            <Tooltip title='Store' placement='bottom'>
              <span>
                <Topbar.Action icon={<LampOutlineIcon size={24} />} onClick={redirectToSpace} />
              </span>
            </Tooltip>
          </PermissionHide>
        </>
      ) : (
        <NoPartner />
      )}

      <ProfileMenu />
    </Topbar>
  );
}

export default React.memo(Toolbar);
